module.exports = __webpack_public_path__ + "media/honey-icons/icon-auto-call-d709feab.svg";